/*
 * `assets` module
 * ===============
 *
 * Declares static asset packs to be loaded using the `Phaser.Loader#pack`
 * method. Use this module to declare game assets.
 */

export default {
  // -- Splash screen assets used by the Preloader.
  boot: [{
    key: 'splash-screen',
    type: 'image'
  }, {
    key: 'progress-bar',
    type: 'image'
  }, {
    key: 'title',
    type: 'image'
  }],

  // -- General assets used throughout the game.
  game: [{
    key: 'phaser',
    type: 'image'
  },{
    key: 'background',
    type: 'image'
  },{
    key: 'menu',
    type: 'image'
  },{
    key: 'menu2',
    type: 'image'
  },{
    key: 'floor',
    type: 'image'
  },{
    key: 'bed',
    type: 'image'
  },{
    key: 'zombie1',
    type: 'image'
  },{
    key: 'zombie2',
    type: 'image'

  },{
    key: 'player3',
    type: 'spritesheet',
    //url: 'example.png',
    margin: 0,
    spacing: 0,
    frameMax: 6,
    frameWidth: 213,
    frameHeight: 242

  // AUDIO

    // http://soundbible.com/905-Cave-In-Sound.html

  },{
    key: 'music1',
    urls: ['music1.mp3'],
    type: 'audio'
  },{
    // http://soundbible.com/1131-Earthquake.html
    key: 'quake',
    urls: ['quake.mp3'],
    type: 'audio'
  },{
    // https://freesound.org/people/toiletrolltube/sounds/181181/
    key: 'whuuup',
    urls: ['whuuup.mp3'],
    type: 'audio'
  }
  ]
};
